<!-- slot.vue -->
<template>
  <div>
    <slot>没有插槽</slot>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {}
};
</script>
